import React, { useState } from "react";
import { Button, CalendarField, TextInputField } from "../../../helpers";
import { FileUpload } from "primereact/fileupload";
import { uploadEWayBillInititalState , uploadEWayBillSchema} from "../../../validation/buyerInvoiceValidation";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { useDispatch } from "react-redux";
import { validateInputs } from "../../../utils";


const UploadEWayBill = (props) => {

    const { handleUploadEWayBillSubmit, buyerInvDate } = props

    const [uploadEWayBill, setUploadEWayBill] = useState(uploadEWayBillInititalState)
    const [formErrors, setFormErrors] = useState({})

    const dispatch = useDispatch()

    const handleUploadEWayBillChange = (e) => {
        const updatedUploadEWayBill = {...uploadEWayBill, [e.target.name]: e.target.value}
        setUploadEWayBill(updatedUploadEWayBill)
    }

    const handleEWayBillUpload = ({files, options}) => {
        const [file] = files
        const fileReader = new FileReader()

        if(file.size > 5242880){
            options.clear()
            return dispatch(raiseToast({severity:'error', detail: 'File size exceeds 5MB', life: 3000}))
        }

        fileReader.onload = (e) => {
            const fileObj = {
                url: file.objectURL,
                documentName: "EWAYBILL_DOCUMENT",
                fileName: file.name,
                dataURI: e.target.result,
            }
            const updatedUploadEWayBill = {...uploadEWayBill, ewayBillDoc: fileObj}
            setUploadEWayBill(updatedUploadEWayBill)
        }
        fileReader.readAsDataURL(file)
        options.clear()
    }

    const handleRemoveEWayBillDoc = () => {
        const updatedUploadEWayBill = {...uploadEWayBill, ewayBillDoc: null}
        setUploadEWayBill(updatedUploadEWayBill)
    }
 
    const handleSubmit = async () => {
        const validationRes = await validateInputs(uploadEWayBillSchema, uploadEWayBill )
        console.log("validation-response", validationRes)
        if (validationRes) {
            if (validationRes.error) {
                setFormErrors(validationRes.error)
            }
            else {
                if(!uploadEWayBill.ewayBillDoc){
                    return dispatch(raiseToast({severity:'error', detail: 'please upload E-Way bill document', life: 3000}))
                }

                setFormErrors({})
                //setUploadEWayBill({...uploadEWayBillInititalState})
                handleUploadEWayBillSubmit(validationRes.result)
            }
        }
    }

    const minEWayBillDate= new Date(buyerInvDate)
    // console.log("minEWayBillDate", minEWayBillDate)

    // console.log("uploadEWayBill", uploadEWayBill)

    return(
        <div>
            <div className="flex justify-cintent-around col-12 mb-2">
                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                    <TextInputField name="ewayBillNo" value={uploadEWayBill.ewayBillNo} labelText="E-way bill No" keyfilter="pnum" onChange={handleUploadEWayBillChange} maxLength={12} errorMessage={formErrors.ewayBillNo} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                    <CalendarField name="ewayBillDate" value={uploadEWayBill.ewayBillDate} minDate={minEWayBillDate} labelText="E-way bill Date" onChange={handleUploadEWayBillChange} errorMessage={formErrors.ewayBillDate } />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0 w-8rem">
                    <label className="text-xs mb-1">E-Way Bill Doc</label>
                    <FileUpload className="upload-btn" mode="basic" name="ewayBillDoc" accept=".pdf"  customUpload auto chooseLabel="Upload File" uploadHandler={files => handleEWayBillUpload(files)} />
                </div>
                <div>
                    {
                        uploadEWayBill.ewayBillDoc &&
                        <div className='flex flex-row mt-3 ml-3 w-15rem'>
                            <label key={uploadEWayBill?.ewayBillDoc?.fileName}> <b className='text-xs'> {uploadEWayBill?.ewayBillDoc?.fileName} &nbsp;&nbsp; </b></label>
                            <Button className="decrement-btn-icon p-0 mb-3 ml-1" icon="pi pi-times-circle" text onClick={handleRemoveEWayBillDoc} size="small" />
                        </div>
                    }
                </div>
            </div>
            <div className="flex justify-content-end">
                <Button label="Submit" onClick={handleSubmit} />
            </div>
        </div>
    )
}

export default UploadEWayBill